import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import WaiverForm from './components/WaiverForm';
import ProgressiveWaiverForm from './components/ProgressiveWaiverForm';
import StreamlinedWaiverForm from './components/StreamlinedWaiverForm';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import Confirmation from './components/Confirmation';
import PublicWaiverConfirmation from './components/PublicWaiverConfirmation';
import Home from './components/Home';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import WaiverCompletePage from './pages/WaiverCompletePage';
import Experience from './pages/Experience';
import KioskInfo from './pages/KioskInfo';
import BirthdayParties from './pages/BirthdayParties';
import { AuthProvider } from './contexts/AuthContext';
import './styles/mobile-fixes.css';
const PianoWorkshopPage = React.lazy(() => import('./pages/PianoWorkshopPage'));

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Main website routes with Layout */}
          <Route path="/" element={<Layout><HomePage /></Layout>} />
          <Route path="/about" element={<Layout><AboutPage /></Layout>} />
          <Route path="/contact" element={<Layout><ContactPage /></Layout>} />
          
          {/* Experience info hub route */}
          <Route path="/experience" element={<Layout><Experience /></Layout>} />
          {/* Kiosk info single page */}
          <Route path="/kiosk-info" element={<Layout><KioskInfo /></Layout>} />
          {/* Waiver routes - keep original styling */}
          <Route path="/waiver" element={<StreamlinedWaiverForm />} />
          <Route path="/waiver-complete" element={<WaiverCompletePage />} />
          <Route path="/waiver/streamlined" element={<div className="min-h-screen bg-gray-50"><StreamlinedWaiverForm /></div>} />
          <Route path="/waiver/progressive" element={<div className="min-h-screen bg-gray-50"><ProgressiveWaiverForm /></div>} />
          <Route path="/waiver/classic" element={<div className="min-h-screen bg-gray-50"><WaiverForm /></div>} />
          <Route path="/confirmation" element={<div className="min-h-screen bg-gray-50"><Confirmation /></div>} />
          <Route path="/waiver-confirmation/:qrCode" element={<div className="min-h-screen bg-gray-50"><PublicWaiverConfirmation /></div>} />
          
          {/* Admin routes - keep original styling */}
          <Route path="/admin/login" element={<div className="min-h-screen bg-gray-50"><AdminLogin /></div>} />
          <Route path="/admin/dashboard" element={<div className="min-h-screen bg-gray-50"><AdminDashboard /></div>} />
          
          {/* Legacy home route */}
          <Route path="/home" element={<div className="min-h-screen bg-gray-50"><Home /></div>} />
          <Route path="/birthday-parties" element={<Layout><BirthdayParties /></Layout>} />
          {/* Robotics Workshop Landing Page */}
          <Route path="/piano-fJo53M9" element={<Layout><Suspense fallback={<div>Loading...</div>}><PianoWorkshopPage /></Suspense></Layout>} />
          <Route path="/workshop/robotics/foundation/intro-simple-piano" element={<Layout><Suspense fallback={<div>Loading...</div>}><PianoWorkshopPage /></Suspense></Layout>} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
